import http from '@utils/http';

/**
 * GET /api/v1/settings/general – user-level settings
 */
export const getGeneralSettings = () => http.get('/settings/general').then((res) => res.data?.data ?? res.data);

/**
 * PATCH /api/v1/settings/general
 * @param {{ pushNotificationsEnabled?: boolean, emailNotificationsEnabled?: boolean, inAppNotificationsEnabled?: boolean }} body
 */
export const patchGeneralSettings = (body) =>
    http.patch('/settings/general', body).then((res) => res.data?.data ?? res.data);

/**
 * PATCH /api/v1/settings/general — sync pinned project IDs for the logged-in user
 * @param {string[]} pinnedProjectIds
 */
export const patchPinnedProjects = (pinnedProjectIds) =>
    http.patch('/settings/general', { pinnedProjectIds }).then((res) => res.data?.data ?? res.data);

/**
 * GET /api/v1/settings/tenant – company-level settings (includes origins for lead capture)
 */
export const getTenantSettings = () => http.get('/settings/tenant').then((res) => res.data?.data ?? res.data);

/**
 * PATCH /api/v1/settings/tenant – update allowed origins only (array of strings)
 * @param {{ origins: string[] }} body
 */
export const patchTenantSettings = (body) =>
    http.patch('/settings/tenant', body).then((res) => res.data?.data ?? res.data);

/**
 * PUT /api/v1/settings/tenant – full tenant settings
 * @param {{ pushNotificationsEnabled?: boolean, emailNotificationsEnabled?: boolean, inAppNotificationsEnabled?: boolean, notificationEmail?: string, origins?: string[] }} body
 */
export const putTenantSettings = (body) =>
    http.put('/settings/tenant', body).then((res) => res.data?.data ?? res.data);

/**
 * GET /api/v1/settings/lead-origins – lead sources (website, open_market, manual, referral)
 */
export const getLeadOrigins = () => http.get('/settings/lead-origins').then((res) => res.data?.data ?? res.data);

/**
 * PUT /api/v1/settings/lead-origins – update lead origins config
 * @param {{ origins: Array<{ source: string, enabled: boolean, config?: object }> }} body
 */
export const putLeadOrigins = (body) =>
    http.put('/settings/lead-origins', body).then((res) => res.data?.data ?? res.data);
